import React from 'react'
import { EIconSize } from '@frontend/pole-ui/lib/components/Icon'
import { LandingAnimation } from '@/components/composed/landingBlocks/LandingAnimation'
import { LANDING_ANIMATION } from '@/components/composed/landingBlocks/LandingAnimation/constants'
import { LandingCardWithIcon } from '@/components/composed/landingBlocks/LandingCardWithIcon'
import { ELandingBenefitsAnimationDelay } from './constants'
import type { TLandingBenefitsProps } from './types'
import './styles.scss'

export const LandingBenefits: React.FC<TLandingBenefitsProps> = ({ title, benefits }) => {
  return (
    <section className="landingBenefits">
      <div className="landingBenefits__wrapper page-wrapper">
        <LandingAnimation desktopTargetStyles={{ ...LANDING_ANIMATION.fadeUp, delay: ELandingBenefitsAnimationDelay.TITLE }}>
          <h2 className="landingBenefits__title">{title}</h2>
        </LandingAnimation>
        <LandingAnimation desktopTargetStyles={{ ...LANDING_ANIMATION.fadeUp, delay: ELandingBenefitsAnimationDelay.LIST }}>
          <ul className="landingBenefits__list">
            {benefits.map(benefit => (
              <li key={benefit.title}>
                <LandingCardWithIcon className="landingBenefits__detail" icon={benefit.icon} iconSize={EIconSize.M}>
                  <h3 className="landingBenefits__detailTitle h4">{benefit.title}</h3>
                </LandingCardWithIcon>
              </li>
            ))}
          </ul>
        </LandingAnimation>
      </div>
    </section>
  )
}
